import { render, staticRenderFns } from "./UiBadges.vue?vue&type=template&id=1ca24ead&"
import script from "./UiBadges.vue?vue&type=script&lang=js&"
export * from "./UiBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports